import React, {createContext, useContext} from 'react'
import {precondition} from '../utils/assertions'
import {Paths} from './pats'

const context = createContext<Paths | null>(null)

export function PathsContextProvider({children}: {children: React.ReactNode}) {
  const paths = new Paths()

  return <context.Provider value={paths}>{children}</context.Provider>
}

export function usePaths() {
  const paths = useContext(context)

  precondition(paths, 'Called usePaths() outside PathsContextProvider')

  return paths
}
